var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-pdf",class:_vm.fileClass},[_c('div',{ref:"file",class:{ pointer: _vm.openLink },attrs:{"src":_vm.fileSrc},on:{"click":_vm.viewOriginal}},[_vm._v("\n    "+_vm._s(_vm.fileName)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }